export enum AuthStoreTypeEnum {
  LEAD_PRO = "LEAD_PRO",
  ECOSYSTEM = "ECOSYSTEM",
}
